import * as React from "react"
import Svg, { Path } from "react-native-svg"

function SvgComponent(props) {
  return (
    <Svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.792 13.125v2.917c0 .805-.653 1.458-1.458 1.458H6.667a1.458 1.458 0 01-1.458-1.458v-2.917a3.958 3.958 0 013.958-3.958h1.667a3.958 3.958 0 013.958 3.958z"
        fill="#919191"
      />
      <Path
        d="M10 8.75a3.125 3.125 0 100-6.25 3.125 3.125 0 000 6.25zM16.25 8.75a2.083 2.083 0 100-4.167 2.083 2.083 0 000 4.167zM3.75 8.75a2.083 2.083 0 100-4.167 2.083 2.083 0 000 4.167z"
        fill="#919191"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.384 16.25H2.5a1.455 1.455 0 01-1.458-1.458v-3.333c0-.608.241-1.191.67-1.621.43-.43 1.014-.671 1.621-.671h.834c.581 0 1.14.222 1.565.617a4.794 4.794 0 00-1.357 3.341v2.917c0 .07.003.14.01.208zM14.268 9.784a2.295 2.295 0 011.565-.617h.834c.607 0 1.19.242 1.62.67.43.43.671 1.014.671 1.622v3.333A1.455 1.455 0 0117.5 16.25h-1.884a2.47 2.47 0 00.009-.208v-2.917a4.794 4.794 0 00-1.357-3.34z"
        fill="#919191"
      />
    </Svg>
  )
}

export default SvgComponent
